import { WeeklyScheduleRules } from "./types";

const MINUTES_PER_HOUR = 60;
const MS_PER_SECOND = 1_000;
const HOURS_PER_DAY = 24;
const DAYS_PER_WEEK = 7;

export const MINUTE_MS = MINUTES_PER_HOUR * MS_PER_SECOND;
const HOUR_MS = MINUTES_PER_HOUR * MINUTE_MS;
const HOURS_IN_WEEK = HOURS_PER_DAY * DAYS_PER_WEEK;

export function formatCountdown(nextPull: Date, now: Date) {
  const minutes = Math.max(
    0,
    Math.ceil((nextPull.getTime() - now.getTime()) / MINUTE_MS)
  );
  const totalHours = Math.floor(minutes / MINUTES_PER_HOUR);
  const days = Math.floor(totalHours / HOURS_PER_DAY);
  const hours = totalHours % HOURS_PER_DAY;
  const remainingMinutes = minutes % MINUTES_PER_HOUR;

  if (days > 0) {
    return `${days}d ${hours}h ${remainingMinutes}m`;
  }

  return hours > 0 ? `${hours}h ${remainingMinutes}m` : `${remainingMinutes}m`;
}

function findPull(
  startHour: number,
  step: 1 | -1,
  schedule: WeeklyScheduleRules
) {
  for (let i = 0; i < HOURS_IN_WEEK; i += 1) {
    const date = new Date((startHour + i * step) * HOUR_MS);
    const day = date.getUTCDay();
    const hour = date.getUTCHours();
    if (schedule.some((s) => s.days.includes(day) && s.hours.includes(hour))) {
      return date;
    }
  }
  return undefined;
}

export function getScheduleWindow(now: Date, schedule: WeeklyScheduleRules) {
  const currentHour = Math.floor(now.getTime() / HOUR_MS);
  return {
    lastPull: findPull(currentHour, -1, schedule),
    nextPull: findPull(currentHour + 1, 1, schedule),
  };
}
